import React from "react";

export default function MSAccess_Year() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Year</h1>
      <p>This is the MSAccess_Year component generated from the SQL JSON.</p>
    </div>
  );
}
